import { ApexOptions } from "apexcharts"
import ReactApexChart from "react-apexcharts"

interface IData {
  username: string
  average_item_separate: number
  total_items?: number
  isAboveAverage?: boolean
}

interface IItemsPerSeparatorProps {
  data: IData[]
  averageItems: number
  title?: string
}

const ItemsPerSeparator = ({ data, averageItems, title = "Total de Itens por Separador" }: IItemsPerSeparatorProps) => {

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
      fontFamily: 'Public Sans, sans-serif',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: data.length > 20 ? '95%' : data.length > 10 ? '80%' : '60%',
        borderRadius: 4,
        dataLabels: {
          position: 'top',
        },
      },
    },
    dataLabels: {
      enabled: data.length <= 15,
      formatter: (val: number) => `${val}`,
      offsetY: -20,
      style: {
        fontSize: '11px',
        fontWeight: 600,
        colors: ['#111827'],
      },
    },
    xaxis: {
      categories: data.map(user => user.username.split('.').join(' ')),
      labels: {
        rotate: data.length > 8 ? -45 : data.length > 5 ? -30 : 0,
        style: { fontSize: '11px' },
        maxHeight: data.length > 8 ? 80 : 60,
        trim: false,
        hideOverlappingLabels: false,
      },
    },
    yaxis: {
      min: 0,
      max:
        data.reduce(
          (acc, current) =>
            (current.total_items || 0) > acc ? (current.total_items || 0) : acc,
          0,
        ) + Math.round((data.reduce((acc, current) => (current.total_items || 0) > acc ? (current.total_items || 0) : acc, 0)) * 0.1),
      decimalsInFloat: 0,
      title: {
        text: 'Total de Itens',
        style: { fontSize: '12px', fontWeight: 600 },
      },
    },
    colors: ['#ff6b6b'],
    grid: {
      borderColor: '#f1f1f1',
      strokeDashArray: 4,
    },
    tooltip: {
      y: {
        formatter: (val: number) => `${val} itens`,
      },
      custom: function({ series, seriesIndex, dataPointIndex, w }) {
        const user = data[dataPointIndex]
        if (!user) return ''

        return `
          <div style="padding: 10px;">
            <strong>${user.username}</strong><br/>
            Total de itens: <strong>${user.total_items || 0}</strong><br/>
            Tempo médio: <strong>${user.average_item_separate} s</strong><br/>
            Status: <strong style="color: #89BD23">
              ${(user.total_items || 0) >= averageItems ? 'Acima da média' : 'Abaixo da média'}
            </strong>
          </div>
        `
      }
    },
    annotations: {
      yaxis: [
        {
          y: averageItems,
          borderColor: '#383B40',
          strokeDashArray: 6,
          borderWidth: 2,
          label: {
            borderColor: '#383B40',
            style: {
              color: '#fff',
              background: '#383B40',
            },
            text: `${averageItems.toFixed(2)}s`,
          },
        },
      ],
    },
  }

  const series: ApexOptions['series'] = [
    {
      name: 'Total de itens por separador',
      data: data.map((user: IData) => user.total_items || 0),
    },
  ]

  return (
    <div>
      {title && (
        <h3 style={{ marginBottom: '20px', fontWeight: 600 }}>
          {title}
        </h3>
      )}
      <div style={{ paddingBottom: data.length > 8 ? '40px' : '20px' }}>
        <ReactApexChart options={options} series={series} type="bar" height={350} />
      </div>
    </div>
  )
}

export default ItemsPerSeparator
